import Box from "./Box";
import ExpandableSection from "./ExpandableSection";
import FilterMenuMaxHeightBox from "./FilterMenuMaxHeightBox";
import RadioButtonLink from "./RadioButtonLink";
import React from "react";
import SmallCaps from "./SmallCaps";
import { useRouter } from "next/router";

function CategoryFilters({ isBrandContext, rootCategory }) {
  const router = useRouter();
  const categories = [...router.query.categories];

  let rootCategoryActive = false;
  if (isBrandContext) {
    if (
      categories.length === 2 &&
      categories[1] === rootCategory.slug.split("/")[1]
    ) {
      rootCategoryActive = true;
    }
  } else {
    if (categories.length === 1 && categories[0] === rootCategory.slug) {
      rootCategoryActive = true;
    }
  }

  const rootCategoryHref = `/${rootCategory.slug}`;

  return (
    <ExpandableSection
      heading={<SmallCaps>Category</SmallCaps>}
      content={
        <FilterMenuMaxHeightBox>
          <Box>
            <RadioButtonLink
              label={`All ${rootCategory.name}`}
              href={rootCategoryHref}
              active={rootCategoryActive}
            />
            {rootCategory.children.map((category) => {
              const categoryActive = `${categories.join("/")}`.startsWith(
                category.slug
              );
              const categoryHref = `/${category.slug}`;
              return (
                <Box pt="12px" key={category.slug}>
                  <RadioButtonLink
                    label={category.name}
                    href={categoryHref}
                    active={categoryActive}
                  />
                  {categoryActive &&
                    category.children &&
                    category.children.length > 0 && (
                      <Box pl={34} pt="12px" pb="7px">
                        {category.children.map((subcategory) => {
                          const subcategoryActive =
                            `${categories.join("/")}` === subcategory.slug;
                          const subcategoryHref = `/${subcategory.slug}`;
                          return (
                            <Box pt="5px" key={subcategory.slug}>
                              <RadioButtonLink
                                label={subcategory.name}
                                href={subcategoryHref}
                                active={subcategoryActive}
                              />
                            </Box>
                          );
                        })}
                      </Box>
                    )}
                </Box>
              );
            })}
          </Box>
        </FilterMenuMaxHeightBox>
      }
    />
  );
}

export default CategoryFilters;
